import { Observable } from 'rxjs';

import UserApi from 'entities/user/api';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';
import DeedsApi from 'entities/deed/api';
import VolunteerTimeApi from 'entities/volunteerTime/api';

import {
  searchSuccessAction,
  searchFailedAction,
  addAttendeesFailedAction,
  addAttendeesSuccessAction,
} from './actions';
import { ADD_ATTENDEES, SEARCH } from './constants';

const addAttendees = (action$) =>
  action$.ofType(ADD_ATTENDEES).mergeMap(({ deedId, users, emails, roles }) =>
    DeedsApi.addAttendees(deedId, users, emails, roles)
      .mergeMap((deedAction) =>
        Observable.from([
          deedAction,
          showMessageAction('Added attendees!'),
          addAttendeesSuccessAction(),
        ])
          // @NOTE-DP: re-fetch VT entries after addAttendees succeeded
          .concat(VolunteerTimeApi.getByFilter({ deedId: { equals: deedId } }, true))
      )
      .catch((e) =>
        Observable.of(addAttendeesFailedAction(e), showErrorAction('Add Attendees Failed!'))
      )
  );

const search = (action$) =>
  action$.ofType(SEARCH).switchMap(({ term }) => {
    if (term.length < 2) {
      return [];
    }
    return UserApi.search(term)
      .takeUntil(action$.ofType(SEARCH))
      .mergeMap((results) => [searchSuccessAction(results)])
      .catch((e) => Observable.of(searchFailedAction(e)));
  });

export default [search, addAttendees];
